export default {
  '确认要修改为噪音?': '确认要修改为噪音?',
};
